import React from "react";
import { Helmet } from "react-helmet";
import MainImage from "../../assets/MainImage.jpg";
import Footer from "../../components/Footer";
import SecondImage from "../../assets/AboutImage4.jpg";
import NavLite from "../../components/NavLite";
import PastWord from "../../components/PastWord";
import SmallTestimony from "../../components/SmallTestimony";

function SanAntonio() {
  return (
    <section>
      <Helmet>
        <title>Web Design & SEO for Women Entrepreneurs in San Antonio | Her Growth Co.</title>
        <meta
          name="description"
          content="Strategic web design and SEO tailored for San Antonio’s female-led businesses. Her Growth Co helps you increase visibility and convert visitors into clients."
        />
        <meta
          name="keywords"
          content="high-end website design texas, premium web design services, austin custom website development, conversion-focused web design, mobile responsive web design austin, website design for coaches, ux/ui website design austin, brand-first website design, premium branding website texas, website design for consultants, creative web design agency austin, bespoke web development texas, web design for personal brands austin, austin expert wordpress designer, strategic website design for leads, lead generation web design austin, custom web graphics austin, lightning-fast websites austin tx, mobile-first web design texas, expert website builder for women entrepreneurs, website design for experts texas, web designer for thought leaders, seo-ready website builds, visually engaging websites texas, ux design for female-led businesses, san antonio web design for women entrepreneurs, san antonio seo for female-led brands, high-end website design san antonio, expert digital branding san antonio, website design agency for women san antonio, conversion-optimized websites san antonio, san antonio cro services for women, custom websites for thought leaders san antonio, niche seo for consultants san antonio, lead-generating websites san antonio tx, personal brand website strategy san antonio, san antonio digital authority package, content marketing for women-led brands san antonio, seo consulting for female founders san antonio, high-ticket website design san antonio, seo and design for coaches san antonio, social media integration san antonio marketing, expert online visibility for women san antonio, web design for premium consultants san antonio, all-in-one authority launchpad san antonio, san antonio women in business digital growth, premium online branding san antonio, custom web services for female founders san antonio, seo and content marketing san antonio tx, san antonio web design for personal brands, high-end digital services for women san antonio"
        />
      </Helmet>

      {/* Hero Section */}
      <div
        className="relative h-auto bg-cover bg-center"
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
          backgroundImage: `url(${MainImage})`,
          padding: "20px",
          width: "100%",
        }}
      >
        <NavLite />
        <div className="p-10">
          <h2 className="text-3xl font-bold uppercase text-black mb-4 text-center">
            <span className="bg-[#CFF098] italic">
              San Antonio Web Design & SEO for Women Entrepreneurs
            </span>
          </h2>
        </div>
      </div>

      {/* CTA Section */}
      <div className="mx-auto w-full max-w-7xl px-5 py-6 md:px-10 md:py-10 flex flex-col items-center text-center">
        <p className="text-gray-200 mb-4 text-2xl max-w-2xl">
          Empowering San Antonio’s women-owned businesses through elevated web design and local SEO. Stand out, get found, and grow confidently.
        </p>
        <a href="https://cal.com/woaomwebdesign/15min">
          <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
            BOOK A FREE STRATEGY CALL →
          </button>
        </a>
      </div>






     {/* Our Process */}
<div className="mx-auto w-full max-w-7xl flex flex-col items-center text-center mt-20">
  <h2 className="text-3xl font-medium md:text-4xl text-white uppercase">
    Our Process
  </h2>
</div>

{/* Centered Paragraph below heading */}
<p className="mx-auto mt-4 max-w-3xl text-sm text-gray-200 sm:text-base md:mb-12 lg:mb-16 text-center">
  We guide San Antonio women founders through a streamlined, empowering process that results in bold websites and real visibility.
</p>

<div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-12">
  {/* Text Section */}
  <div className="flex flex-col justify-center w-full md:w-1/2">
    {[
      {
        step: 1,
        title: "Clarity Call",
        desc: "We begin with a deep dive into your business goals, ideal audience, and brand vision.",
      },
      {
        step: 2,
        title: "Design & Development",
        desc: "We design a responsive, elegant site that captures your voice and converts browsers into buyers.",
      },
      {
        step: 3,
        title: "SEO for San Antonio",
        desc: "We build a local SEO strategy that helps San Antonio clients discover your business online.",
      },
      {
        step: 4,
        title: "Launch & Scale",
        desc: "We support you beyond launch with SEO and strategic guidance to keep your growth going strong.",
      },
    ].map(({ step, title, desc }) => (
      <div key={step} className="mb-8 flex max-w-lg justify-center gap-4 px-6 py-5 text-black">
        <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-gray-100">
          <p className="text-sm font-bold sm:text-base">{step}</p>
        </div>
        <div className="ml-4 flex flex-col gap-2">
          <h5 className="text-xl font-medium uppercase text-white">{title}</h5>
          <p className="text-sm text-gray-200">{desc}</p>
        </div>
      </div>
    ))}
  </div>

  {/* Image Section */}
  <div className="w-full md:w-1/2 flex items-stretch">
    <img
      alt="Website Design for Women Entrepreneurs San Antonio"
      src={MainImage}
      className="w-full object-cover"
    />
  </div>
</div>








      {/* Past Work & Testimonials */}
      <PastWord />
      <SmallTestimony />

      {/* About Us Section */}
      <div className="mx-auto w-full">
        <div className="grid gap-6 sm:gap-6 md:grid-cols-2">
          <div className="flex flex-col items-start gap-2 md:py-24 md:px-24 max-w-[600px] p-4">
            <div className="flex items-center rounded-md py-1">
              <p className="text-sm uppercase mb-12">ABOUT US</p>
            </div>
            <h4 className="mb-6 text-2xl font-semibold md:text-3xl md:mb-8 uppercase">
              Supporting{" "}
              <span className="italic text-black bg-[#CFF098]">
                San Antonio Women Entrepreneurs
              </span>{" "}
              with{" "}
              <span className="italic text-black bg-[#CFF098]">
                Strategic Design & SEO
              </span>
            </h4>
            <p className="text-sm text-white sm:text-xl">
              At our core, we’re passionate about helping women-led businesses in San Antonio thrive. From high-end website design to smart SEO that connects you to your dream clients, our services are built with your success in mind.
              <br />
              <br />
              Whether you're launching something new or leveling up an established brand, we’re here to guide and grow with you.
            </p>
            <p className="mt-6 mb-6 text-xl italic uppercase">
              Let’s build something bold, beautiful, and totally *you*.
            </p>

            <div className="flex flex-col gap-4 font-regular sm:flex-row">
              <a
                href="/about"
                className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-2 text-black hover:opacity-60 text-sm"
              >
                <p>LEARN MORE ABOUT US →</p>
              </a>
            </div>
          </div>

          <div className="relative w-full h-[]">
            <img
              src={SecondImage}
              alt="San Antonio women entrepreneur using laptop"
              className="absolute top-0 right-0 w-auto h-full object-cover"
            />
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
}

export default SanAntonio;
